var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 581.46 563.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#961a27;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,347.31S-23.54,13.42,213.46,21.42C300.37,24.35,359.84,15.6,400.3,3.34c69.06-20.92,123.34,61.05,76.24,115.73-32.68,37.94-99.44,66.29-228,62.81a169.8,169.8,0,0,1-19.88-1.71C198.93,175.83,77.88,170.22,1.76,347.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M463.08,132.42S602,207.83,563.23,350.12H526.3s5.62-115.06-100.61-194.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,347.31,30,347.7s21.62-96.7,73-135l-65.58-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M485.4,107.33s63.23,53.79,73.65,133.94-73.65-67-73.65-67l-42-41.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "402.5 164.73 395.46 204.42 452.25 178.41 459.46 141.42 415.34 141.42 402.5 164.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.76,347.31S33.54,543.51,0,564c0,0,74.53-9,30-216.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.4,122.33s68.06-64.91,116.06-37.91C581.46,84.42,487.35,97.25,465.4,122.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset11);
export default __webpack_public_path__ + "static/media/Asset 11.c3c380ac.svg";
export { ForwardRef as ReactComponent };